import React from 'react'

import Title from 'components/base/Title'
import Paragraph from 'components/base/Paragraph'
import LocationIcon, { Theme as LocationIconTheme } from 'components/base/Icon/LocationIcon'

import {
  Wrap, GroupItem, Phone,
} from './styles'

import { Props } from './types'

const RetailLounge: React.FC<Props> = ({
  children,
  hoursWeekday,
  hoursWeekend,
  phone,
}): React.ReactElement => (
  <Wrap>
    <GroupItem>
      <LocationIcon theme={LocationIconTheme.hours} />
      <Title level={3}>Hours</Title>
      <Paragraph>
        Monday ⁠– Friday
        <br />
        {hoursWeekday}
      </Paragraph>
      <Paragraph>
        Saturday ⁠– Sunday
        <br />
        {hoursWeekend}
      </Paragraph>
    </GroupItem>
    <GroupItem>
      <LocationIcon theme={LocationIconTheme.phone} />
      <Title level={3}>Phone</Title>
      <Phone>{phone}</Phone>
    </GroupItem>
    <GroupItem>
      <LocationIcon theme={LocationIconTheme.address} />
      <Title level={3}>Address</Title>
      <Paragraph>{children}</Paragraph>
    </GroupItem>
  </Wrap>
)

export default RetailLounge
